<dx-select-box [dataSource]="dataSource"
               [value]="systemEntityId"
               (onValueChanged)="onSystemEntityIdChanged($event)"
               [searchEnabled]="true"
               valueExpr="systemEntityId"
               displayExpr="name"></dx-select-box>
